module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapname1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_Part01#p1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("PART 1 ‘WACHT AM RHEIN’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09_Chapter01#h2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The Decision to Regain the Initiative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/10_Chapter02#h2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Operational Planning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/11_Chapter03#h2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Condition of the Attack Force")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/12_Chapter04#h2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Orders for Deception and Secrecy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/13_Chapter05#h2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Orders for the Attack")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/14_Chapter06#h2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("‘Wacht am Rhein’: Order of Battle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_Chapter07#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Build-up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_Chapter08#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Special Operations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_Chapter09#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The Panzer Spearheads")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_Chapter10#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The Failure of Allied Intelligence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_Chapter11#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Hitler’s Final Comments at FHQu ‘Adlerhorst’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_Part02#p2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("PART 2 BREAKTHROUGH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_Chapter12#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("6. PANZER-ARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_Chapter13#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("LXVII. Armeekorps stopped on the northern flank")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_Chapter14#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Operation ‘Stösser’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_Chapter15#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("I. SS-Panzerkorps: Elsenborn Ridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_Chapter16#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Rollbahn C: 12. SS-Panzer-Division")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_Chapter17#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Operation ‘Greif’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_Chapter18#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("I. SS-Panzerkorps: Kampfgruppe Peiper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/28_Chapter19#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("5. PANZER-ARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_Chapter20#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("LXVI. Armeekorps: the Schnee Eifel and Saint-Vith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/30_Chapter21#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("LVIII. Panzerkorps reaches Hotton")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/31_Chapter22#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("XXXXVII. Panzerkorps advances west of Bastogne")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/32_Chapter23#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("7. ARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33_Chapter24#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("LXXXV. Armeekorps crosses the Our")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/34_Chapter25#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("LXXX. Armeekorps battles west of the Sûre")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/35_Part03#p3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("PART 3 HIGH TIDE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/36_Chapter26#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("6. PANZERARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/37_Chapter27#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Evacuation of the Saint-Vith salient")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/38_Chapter28#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("I. SS-Panzerkorps: the end of Kampfgruppe Peiper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/39_Chapter29#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("II. SS-Panzerkorps checked at Manhay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/40_Chapter30#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("5. PANZERARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/41_Chapter31#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("LVIII. Panzerkorps fails east of Marche")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/42_Chapter32#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Nuts! XXXXVII. Panzerkorps at Bastogne")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/43_Chapter33#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("XXXXVII. Panzerkorps glimpses the Meuse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/44_Chapter34#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("7. ARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/45_Chapter35#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The US Third Army counter-attack")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/46_Chapter36#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("US III Corps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/47_Chapter37#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("US XII Corps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/48_Part04#p4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("PART 4 THE BEGINNING OF THE END")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/49_Chapter38#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("‘We shall yet master fate’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/50_Chapter39#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Allied counter-plans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/51_Chapter40#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("6. PANZER-ARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/52_Chapter41#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("II. SS-Panzerkorps’ attempt to break through at Erezée")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/53_Chapter42#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("5. PANZER-ARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/54_Chapter43#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Fight to cut the Bastogne Corridor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/55_Chapter44#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Third Army’s attack develops")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/56_Chapter45#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("ARMEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/57_Part05#p5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("PART 5 ESCAPE FROM THE SALIENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/58_Chapter46#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Heeresgruppe G and Operation ‘Nordwind’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/59_Chapter47#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("New Year’s Day — Operation ‘Bodenplatte’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/60_Chapter48#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Bastogne: Epilogue to Failure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/61_Chapter49#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The pressure mounts: The First Army counter-attacks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/62_Chapter50#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The threat from the Third Army along the Our")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/63_Chapter51#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Finis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/64_Chapter52#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The Cost")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/65_Part06#p6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("PART 6 THE BATTLEFIELD TODAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/66_Chapter53#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The Memorials")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/67_Chapter54#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("The Museums")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/68_Table#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("COMPARATIVE RANK TABLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/69_Awards#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("THE AWARDS: Ritterkreuz, Medal of Honor, Distinguished Service Cross")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/70_Bibliography#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("SELECT BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/71_Military#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("MILITARY UNIT SIGNS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/72_Author1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("AUTHOR’S POSTSCRIPT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/73_Index#h2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f66973fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/06_Contents.vue
// module id = 72
// module chunks = 0